import Navbar from "./components/Navbar";
import Seccion1 from "./components/Seccion1";
import Seccion2 from "./components/Seccion2";
import Seccion3 from "./components/Seccion3";
import Seccion4 from "./components/Seccion4";
import Seccion5 from "./components/Seccion5";
import Contacto from "./components/Contacto";
import './index.css';  // Asegúrate de que esta ruta sea correcta
import { Helmet } from 'react-helmet';



export default function App() {
  return (
    <div>
      <Helmet>
        <title>Carlos Laspina - Pericias en Incendios</title>
        <meta name="description" content="Servicios de investigación y análisis de incendios, análisis de riesgos, seguridad contra incendios y capacitaciones especializadas." />
        <meta name="keywords" content="Investigación de incendios, Análisis de riesgos, Seguridad contra incendios, Capacitación en incendios" />
        <meta name="author" content="Carlos Laspina" />

        {/* Open Graph Meta Tags para compartir en redes sociales */}
        <meta property="og:title" content="Carlos Laspina - Pericias en Incendios" />
        <meta property="og:description" content="Proporcionamos servicios de alta calidad en investigación de incendios y seguridad." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.carloslaspina.com" />
        <meta property="og:image" content="https://www.tuempresa.com/imagen-og.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tu Empresa - Especialistas en Investigación de Incendios" />
        <meta name="twitter:description" content="Servicios de investigación de incendios y seguridad para empresas y organismos gubernamentales." />
        <meta name="twitter:image" content="https://www.tuempresa.com/imagen-twitter.jpg" />

        {/* Canonical URL para evitar contenido duplicado */}
        <link rel="canonical" href="https://www.carloslaspina.com" />
      </Helmet>

      {/* Navbar */}
      <Navbar />

      {/* Secciones */}
      <main className="mt-16">
        <section id="seccion1">
          <Seccion1 />
        </section>
        <section id="seccion2">
          <Seccion2 />
        </section>
        <section id="seccion3">
          <Seccion3 />
        </section>
        <section id="seccion4">
          <Seccion4 />
        </section>
        <section id="seccion5">
          <Seccion5 />
        </section>
        <section id="contacto">
          <Contacto />
        </section>
      </main>
    </div>
  );
}
